import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { ApiError } from '../../api/client'
import {
  groupDispatchingShellQuery,
  saveGroupDispatch,
  type DispatchGroup,
} from '../../api/settingsEaseedeskGroupDispatching'
import { LoadFailed } from '../../ui/LoadFailed'
import { toast } from '../../ui/notify'
import { Spinner } from '../../ui/Spinner'

/**
 * Settings → Easeedesk → Group dispatching.
 *
 * Element cu element fata de `version-3/easeedesk_settings/tickets/
 * group_dispatching/index.php`, si gest cu gest fata de `index-1.js`: casuta
 * salveaza la schimbare, fara buton.
 */
export function GroupDispatchingPage() {
  const queryClient = useQueryClient()
  const shell = useQuery(groupDispatchingShellQuery())

  const reload = () => {
    void queryClient.invalidateQueries({ queryKey: ['settings', 'easeedesk', 'group_dispatching'] })
  }

  if (shell.error instanceof ApiError && shell.error.status === 403) {
    return (
      <div className="alert alert-danger">
        <i className="fas fa-exclamation-circle" aria-hidden="true"></i> You do not have access to this action.
      </div>
    )
  }
  if (shell.error) {
    return <LoadFailed error={shell.error} onRetry={() => void shell.refetch()} what="This screen" />
  }
  if (!shell.data) return <Spinner />

  return (
    <div>
      <h4>
        <strong>Group</strong> dispatching
      </h4>
      <label className="color" style={{ marginBottom: 0 }}>
        Configure group dispatching ticket
      </label>
      <hr />

      <div className="row">
        <div className="col-md-12">
          <div className="list-group">
            {shell.data.groups.map((group) => (
              <GroupRow key={group.ID} group={group} types={shell.data.ticket_types} onSaved={reload} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

function GroupRow({
  group,
  types,
  onSaved,
}: {
  group: DispatchGroup
  types: { ID: number; type_name: string }[]
  onSaved(): void
}) {
  const [type, setType] = useState(group.ticket_type_id)

  useEffect(() => setType(group.ticket_type_id), [group.ticket_type_id])

  const save = useMutation({
    mutationFn: (next: number) => saveGroupDispatch(group.ID, next),
    onSuccess: onSaved,
    onError: () => toast('Something went wrong.', 'Error', 'error'),
  })

  return (
    <section className="settings">
      <div className="row">
        <div className="col-md-4">
          <i className="fas fa-users"></i> {group.department_name}
        </div>
        <div className="col-md-4">
          <select
            className="form-control dispatch_ticket_type"
            name="ticket_type"
            value={type === 0 ? '' : String(type)}
            onChange={(e) => {
              const next = e.target.value === '' ? 0 : Number(e.target.value)
              setType(next)
              save.mutate(next)
            }}
          >
            <option value="">Select...</option>
            {types.map((option) => (
              <option key={option.ID} value={option.ID}>
                {option.type_name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <hr className="dotted" />
    </section>
  )
}
